// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';
const KEY_FIELD_MANAGERS="fieldManagers"
const SIZE = 10;

export default {
  fetch(lastmodified) {
    return new Promise((resolve) => {
      db.ref("log")
        .child("logs")
        .child(KEY_FIELD_MANAGERS)
        .orderByChild("modified")
        .endAt(lastmodified-1)
        .limitToLast(SIZE)
        .once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        
        const result =  {
          data: list.reverse(),
          last: list.length < SIZE
        }

        resolve(result)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/field-manager/field-manager-history/field-manager-history-single/field-manager-history-single-service.js